import React, { useState, useEffect } from 'react';
import { Modal, notification } from 'antd';
import Table from 'components/Table';
import { Breadcrumbs } from 'components/Atom/breadcumbs';
import { ResetButton, Button } from 'components/Atom/Button';
import { PageHeader } from 'components/Atom/PageHeader';
import '../assets/style.css';
import { useSelector } from 'react-redux';
import { TIMEZONES } from 'utils/constant';
import { useQuery } from 'react-query';
import SearchField from 'components/Atom/SearchField/index';
import { PlusOutlined } from '@ant-design/icons';
import { formatInTimeZone } from 'date-fns-tz';
import { getRuleList, getSingleRule, deleteRule } from 'api/xShields';
import { checkUserPermissions } from 'utils/services';
import { USER_ROLES } from 'utils/constant';
import StatusTag from 'components/Atom/StatusTag';
import CreateFraudRuleModal from './createRule';

export const Rules = () => {
  const store = useSelector((state) => state.company.store);
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const [deleteRuleModal, setDeleteRuleModal] = useState(false);
  const [ruleData, setRuleData] = useState({});
  const [isRuleDeleting, setIsRuleDeleting] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const userStoresData = useSelector((state) => state.company.userStores);
  const [filteredRuleList, setFilteredRuleList] = useState([]);
  const timezone = store?.settings?.timezone || TIMEZONES.PKT;
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [selectedRule, setSelectedRule] = useState(null);

  const breadcrumbProps = {
    breadcrumbs: [
      {
        name: 'XPay',
        href: '/xpay',
      },
      {
        name: 'XShield',
      },
      {
        name: 'Rules',
      },
    ],
  };

  const getRuleListData = async () => {
    try {
      const params = { ...(store?.isSelected ? { store_id: store?._id } : { store_id: userStoresData[0]?._id }) };
      const response = await getRuleList(params);
      return response?.data?.data;
    } catch (err) {
      console.log(err);
    }
  };
  const {
    data: ruleListData,
    refetch,
    isLoading: isFetching,
  } = useQuery('ruleListData', getRuleListData, {
    enabled: false,
    manual: true,
  });

  useEffect(() => {
    if (store?.features?.includes('XShield')) {
      refetch();
    }
  }, [store]);

  useEffect(() => {
    if (!search) {
      setFilteredRuleList(ruleListData?.fraud_rules || []);
    }
  }, [ruleListData, search]);

  const handleFileSelectionModel = () => {
    if (store?.isSelected) {
      setOpen(true);
    } else {
      notification.error({
        message: 'Store Selection Required',
        description: 'Please select a store from the drop-down menu above to continue',
        placement: 'bottomRight',
      });
    }
  };
  const handleDeleteRule = async (id) => {
    setIsRuleDeleting(true);
    const response = await deleteRule(store?._id, id);
    if (response) {
      setDeleteRuleModal(false);
      refetch();
    }
    setIsRuleDeleting(false);
  };

  const handleUpdate = async (data) => {
    setIsEdit(true);
    setOpen(true);
    const response = await getSingleRule(store?._id, data?._id);
    response?.data?.data;
    setRuleData(response?.data?.data);
  };

  const handleView = async (data) => {
    setSelectedRule(data);
    setViewModalOpen(true);
  };

  const ruleListcolumns = [
    {
      title: 'Rule name',
      render: (value) => (
        <div
          style={{
            maxWidth: 350,
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
          }}>
          {value?.name}
        </div>
      ),
      key: 'name',
    },
    {
      title: 'Status',
      render: (value) => <StatusTag tag={value?.enabled === true ? 'Active' : 'Inactive'} />,
      key: 'status',
    },
    {
      title: 'Last updated',
      render: (value) => (value?.updatedAt ? formatInTimeZone(value?.updatedAt, timezone, 'MMM d, yyyy h:mm:ss a') : ''),
      key: 'updatedAt',
    },
    ...(checkUserPermissions([USER_ROLES.XPAY_ADMIN, USER_ROLES.XPAY_RESTRICTED_ADMIN])
      ? [
          {
            title: 'Action',
            key: 'action',
            render: (data, index) => {
              return (
                <div key={index} className='flex items-center gap-2'>
                  <div type='primary' className='table-action-btn' onClick={() => handleUpdate(data)} style={{ cursor: 'pointer' }}>
                    Update
                  </div>
                  <div type='primary' className='table-action-btn' onClick={() => handleView(data)} style={{ cursor: 'pointer' }}>
                    View
                  </div>
                  <div
                    type='primary'
                    className='table-action-btn'
                    onClick={() => {
                      setRuleData(data), setDeleteRuleModal(true);
                    }}
                    style={{ cursor: 'pointer' }}>
                    Delete
                  </div>
                </div>
              );
            },
          },
        ]
      : []),
  ];
  const handleSearch = () => {
    if (!search) return;
    const filteredRules = ruleListData?.fraud_rules?.filter((rule) => rule?.name?.toLowerCase() === search?.toLowerCase());
    setFilteredRuleList(filteredRules);
  };
  const handleSearchData = () => {
    setSearch('');
  };
  return (
    <>
      <div className='xshield' style={{ padding: '0px', width: '100%' }}>
        <div className='header-container'>
          <Breadcrumbs {...breadcrumbProps} />
          <div className='headerPage'>
            <div className=''>
              <PageHeader label={'Rules'} button={<ResetButton onClick={isFetching ? '' : () => refetch()} loading={isFetching} />} />
            </div>
          </div>
        </div>
        <div className='action_Panel headerContainer' style={{ width: '100%', marginTop: '24px', marginBottom: '20px' }}>
          <div className='searchInput'>
            <SearchField
              handleOnChange={(e) => setSearch(e?.target?.value)}
              value={search}
              handlePressEnter={handleSearch}
              onReset={handleSearchData}
              placeholder={`Search rules`}
              loading={!!(isFetching && search)}
              dropdown={{ show: false }}
              enableSearchBtn={true}
              style={{ width: '360px' }}
            />
          </div>
          <div style={{ display: 'flex', gap: '12px' }} className='action-buttons'>
            {checkUserPermissions([USER_ROLES.XPAY_ADMIN, USER_ROLES.XPAY_RESTRICTED_ADMIN]) && (
              <Button
                disabled={''}
                className='custom-btns primaryBtn p-2 w-[140px] flex items-center'
                onClick={() => {
                  handleFileSelectionModel();
                }}>
                <PlusOutlined className='inline text-base' /> <span className='text-base'>Create Rule</span>
              </Button>
            )}
          </div>
        </div>
        <div className='table-container overflow-x-auto custom-table mb-6'>
          <Table loading={isFetching} columns={ruleListcolumns} dataSource={filteredRuleList} totalLenght={filteredRuleList?.length} pagingation={{ perPageSize: 20, page: 1 }} />
        </div>
        <CreateFraudRuleModal isOpen={open} isEdit={isEdit} setIsEdit={setIsEdit} ruleData={ruleData} refetch={refetch} onClose={() => setOpen(false)} />
      </div>
      <Modal
        open={deleteRuleModal}
        centered
        width={400}
        onCancel={() => {
          setDeleteRuleModal(false);
        }}
        footer={false}
        okButtonProps={{ loading: isRuleDeleting }}
        destroyOnClose>
        <header className='font-semibold text-base mb-4'>Delete Rule</header>
        <div className='mb-8'>
          Are you sure you want to delete this rule {ruleData?.name}
          <span>{'?'}</span>
        </div>
        <div className='flex mt-4 popupConfirmBtn'>
          <Button
            onClick={() => {
              setDeleteRuleModal(false);
            }}
            block
            className='rounded-lg bg-plain'>
            Cancel
          </Button>
          <Button className='DeleteBtn ml-4 rounded-lg' block onClick={() => handleDeleteRule(ruleData?._id)} loading={isRuleDeleting}>
            Confirm
          </Button>
        </div>
      </Modal>
      <Modal
        open={viewModalOpen}
        centered
        width={600}
        onCancel={() => {
          setViewModalOpen(false);
        }}
        footer={false}
        destroyOnClose>
        <header className='font-semibold text-base mb-4'>View Rule Details</header>
        <div style={{ padding: '8px', display: 'flex', gap: '12px' }}>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <strong style={{ paddingBottom: '4px' }}>Name:</strong> <strong>Rule:</strong>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ paddingBottom: '4px' }}>{selectedRule?.name || '-'}</div>
            <div>{selectedRule?.rule || '-'}</div>
          </div>
        </div>
        <div className='flex mt-4 popupConfirmBtn' style={{ justifyContent: 'end' }}>
          <Button
            onClick={() => {
              setViewModalOpen(false);
            }}
            block
            style={{ width: '40%' }}
            className='rounded-lg bg-plain'>
            Cancel
          </Button>
        </div>
      </Modal>
    </>
  );
};
